import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { selectMeteorologyAgroWBSequentialMapsPeriodStart } from 'redux/reducers/meteorologyAgroWBSequentialMapsReducer';
import useLocationMarkers from '../../useLocationMarkers';

export default function useMapLocationMarkers() {
  const navigate = useNavigate();
  const locationMarkers = useLocationMarkers();
  const periodStart = useSelector(selectMeteorologyAgroWBSequentialMapsPeriodStart);

  const mapLocationMarkers = useMemo(() => (
    locationMarkers?.map((marker) => ({
      ...marker,
      onClick: () => {
        navigate('/agro/water-balance-sequential/detailed-view', {
          state: {
            groupId: marker.groupId,
            locationId: marker.locationId,
            periodStart,
          },
        });
      },
    }))
  ), [locationMarkers, navigate, periodStart]);

  return mapLocationMarkers;
}
